import HtmlParser from 'html-react-parser';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';


function HeroModal() {
	const [modalShow, setModalShow] = React.useState(false);

	const handleModalClose = () => setModalShow(false);
	const handleModalShow = () => setModalShow(true);

	return (
		<div className="d-flex mt-1 mb-1">
			<Button variant="" onClick={handleModalShow} className="cta cta-video">See it in action</Button>

			<Modal show={modalShow} onHide={handleModalClose} centered>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>
					<ResponsiveEmbed aspectRatio="16by9">
						<ReactPlayer
							url='https://youtu.be/Hkh9JYTfKWs'
							playing
							volume={1}
							controls={true}
							width='100%'
							height='100%'
						/>
					</ResponsiveEmbed>

				</Modal.Body>
			</Modal>
		</div>
	);
}

const EmployeeExperience = (props) => {

    const location = props.location;

    return (
        <Layout  bodyClass="page-integrations planning" ontouchstart>
            <SEO title="Employee Experience - People Analytics, Visualized - ChartHop" />
            <Helmet>
                <meta
                    name="description"
                    content="Nurture the employee experience and understand the impact all in one place. Discover how ChartHop can help you capture employee sentiment, understand data in context, and streamline HR workflows."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Employee Experience - People Analytics, Visualized - ChartHop" />
                <meta property="og:description" content="Nurture the employee experience and understand the impact all in one place. Discover how ChartHop can help you capture employee sentiment, understand data in context, and streamline HR workflows." />
                <meta property="og:image" content={`https://www.charthop.com/home/meta-home.gif`} />
                <meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Employee Experience - People Analytics, Visualized - ChartHop" />
                <meta name="twitter:description" content="Nurture the employee experience and understand the impact all in one place. Discover how ChartHop can help you capture employee sentiment, understand data in context, and streamline HR workflows." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/meta-home.gif`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>

            {/* HERO CONTENT */}
            <section className="intro container">
                <div className="row py-5 align-items-center">
                    <div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
                        <h1 className="smaller-h1">Data-driven, inclusive employee experience programs</h1>
                        <p className="header-p pb-1 pt-1">Nurture the employee experience and understand the impact — all in one place.</p>
                        <div className="splitText"><DemoFormShort source={"platform-planning-demo-header"} /></div>   
						<HeroModal />                     
                    </div>
					<div className="reactPlayerContainer col-md-6 order-md-1 padding-top-video-one">                        
                        <img className="imageBoxShaddow fullSegmentImage mx-auto" src={'/platform/employee-experience/hero.png'} alt="ChartHop Employee Experience Image" />
					</div>
                </div>
            </section>


			{/* never */}
            <section className="sectionSpacing flex-centeredColumn backgroundGradientContainer">
            	<h2 className="text-center mt-0 sectionSpacing-Margin">
            		At last, a single place to build and <br className="onlyDesktop" /> measure employee experience programs
            	</h2> 
            	<div className="flex-centeredColumn contentBlock">
					<div className="svg-info ">
                    <div className="svg-info-card-3col">
							<img src={'/platform/employee-experience/table.svg'} alt="Visualize" />
							<h3>Capture employee sentiment</h3>
							<p>
								Build surveys to measure the employee experience with an easy-to-use form builder.
							</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/platform/employee-experience/graph.svg'} alt="Put a face to the name" />
							<h3>See data in context</h3>
							<p>
								Create contextual reports to visualize engagement data alongside any other people data.
							</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/platform/employee-experience/settings.svg'} alt="Time Saving" />
							<h3>Streamline HR workflows</h3>
							<p>
								Run engagement surveys, recognition programs, manager check-ins, and more all from a single solution.
							</p>
						</div>
					</div>
				</div>
            </section>

			{/* team */}
			<section className="sectionSpacing">
				<div className="contentBlock">
					<MultimedialPanel 
                        multimediaPosition="left"
                        title="Measure employee engagement, in context"
                        link="/platform/employee-experience/Contextual_Data.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>
                                	Build surveys to measure any part of the employee experience, from pulse surveys to eNPS to onboarding and exit surveys.
                                </p>
                                <p>
                                	Then create contextual reports and dashboards to track results and see engagement data trends side-by-side with other data, such as compensation, demographics, performance, and more -- all with a few clicks, no data scientist or analytics specialist required.
                                </p>
                            </React.Fragment>
                        }
                    />					
				</div>
			</section>

			{/* Collaborate */}
			<section className="sectionSpacing backgroundGradientContainer">
				<div className="contentBlock">
					<MultimedialPanel 
                        multimediaPosition="right"
                        title="Foster a positive and inclusive culture for a distributed workforce"
                        link="/platform/employee-experience/ShoutOuts.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>
                                	Celebrate your people’s accomplishments by administering an employee recognition program through an easy-to-use form that’s accessible to the entire organization.
                                </p>
                                <p>
                                	Add transparency and visibility through rich employee profiles that allow people to get to know their co-workers better. To really bring it all together, overlay these profiles on an org chart and in a map view to help distributed teams better visualize the organization. 
                                </p>
                            </React.Fragment>
                        }
                    />	
				</div>
			</section>

			{/* impact */}            
            <section className="sectionSpacing">
				<div className="contentBlock">
					<MultimedialPanel 
                        multimediaPosition="left"
                        title="Streamline HR workflows"
                        link="/platform/employee-experience/Forms.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>
                                	Simplify where employees need to go for different HR tasks by centralizing everything in a single solution.
                                </p>
                                <p>
                                	From engagement surveys and recognition programs to standardized manager check-ins, this also allows your HR team to bring together all of their workflows for a bigger picture view.
                               	</p>
                            </React.Fragment>
                        }
                    />						
				</div>
			</section>

			<div className="sectionSpacing-Margin mx-0 mt-0">
				<h4 className="listTitle mt-0 text-center pt-3">The complete solution for employee engagement.</h4>
				<div className="flex-centeredColumn contentBlock text-center">
				<div className="pgc1 display-block-pgc1" style={{maxWidth:"1000px"}}>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Employee engagement surveys</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Onboarding/offboarding surveys</p>
							</div>
						</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Manager 1-1s</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>eNPS</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Employee recognition programs</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Individual goal setting</p>
						</div>
					</div>
				</div>
				</div>
				<p class="subListTitle mb-0 font-weight-bold text-center">&amp; more</p>
			</div>

            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo request-demo-white pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"platform-planning-demo-bottom"} centerContent={true} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">“Having used other solutions in past roles, I appreciate that the functionality in ChartHop allows leaders to be agile and hands-on with survey questions without relying on an external team.”</p><p class="contactAuthor"><strong>Alison Crawford</strong> <br>Global Head of Diversity and Inclusion, Ripple<br></p></div></div>')}/>
			</section>
        </Layout>
    );
};


export default EmployeeExperience;